import { useGetVenue } from '@cocoonspace/sdk-js/domains/spaces/spaces'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { MainContainer } from '~/components/atoms/main-container'
import { AdresseBreadcrumb } from './_components/venue-breadcrumb'
import { VenueInfo } from './_components/venue-info'
import { VenueSpaces } from './_components/venue-spaces'

const VenuePhotos = dynamic(
	() => import('./_components/venue-photos').then((mod) => mod.VenuePhotos),
	{ ssr: false },
)

export const VenueDetailsPage = () => {
	const router = useRouter()
	const venueDetailsQuery = useGetVenue(router.query.slug as string)

	if (!venueDetailsQuery.data?.data) return null

	return (
		<MainContainer>
			<AdresseBreadcrumb venue={venueDetailsQuery.data.data} />

			<div className='grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-x-4 lg:grid-cols-3'>
				<VenuePhotos venue={venueDetailsQuery.data.data} />
				<VenueInfo venue={venueDetailsQuery.data.data} />
			</div>

			<VenueSpaces venue={venueDetailsQuery.data.data} />
		</MainContainer>
	)
}
